//Local Imports
import { isEmpty } from "underscore";
import { Axios } from "../axios";
import { IAuth } from "./auth";
//End Local Import

// const baseApi = process.env.REACT_APP_SERVER_ID;
const apiUrl = process.env.REACT_APP_SERVER_ID;
const baseApi = process.env.REACT_APP_NEW_AUTH_SERVER_ID;

export const sendOtp = async ({ body, apiType }: IAuth.ISendOtpProps) => {
  let end_of_url = "";

  if (body.otpType === "mobile") {
    end_of_url = "sendMobileOtp";
  }

  if (body.otpType === "email") {
    end_of_url = "sendEmailOtp";
  }

  if (apiType === "resend") {
    end_of_url = "resendOtp";
  }

  return await Axios.post(`${baseApi}/remit/auth/${end_of_url}`, body, {
    headers: {
      "Access-Control-Allow-Origin": "true",
      "Content-Type": "application/json",
      accept: "*/*",
      "X-Route-To": "authservice",
    },
  });
};

export const validateOtp = async (body: IAuth.IValidateOtpProps) => {
  return await Axios.post(`${baseApi}/remit/auth/validateOtp`, body, {
    headers: {
      "Access-Control-Allow-Origin": "true",
      "Content-Type": "application/json",
      accept: "*/*",
      "X-Route-To": "authservice",
    },
  });
};

export const registerUserData = async (body: IAuth.IRegisterUserDataProps) => {
  return await Axios.post(`${baseApi}/remit/auth/signup`, body, {
    headers: {
      "Access-Control-Allow-Origin": "true",
      "Content-Type": "application/json",
      accept: "*/*",
      "partner-type": "moneyhop",
      "X-Route-To": "authservice",
    },
  });
};

export const handleLogin = async (body: IAuth.IHandleLoginProps) => {
  const apiBody = {
    email: body.email,
    password: body.password,
  };

  return await Axios.post(`${baseApi}/remit/auth/signin`, apiBody, {
    headers: {
      "Access-Control-Allow-Origin": "true",
      "Content-Type": "application/json",
      "partner-type": "moneyhop",
      "X-Route-To": "authservice",
      accept: "*/*",
      //@ts-ignore
      emailVerified: body.isOtpVerified,
    },
  });
};

export const isAuthorised = async (currentUser: IAuth.IIsAuthorisedProps) => {
  if (!(currentUser === null || currentUser === undefined || isEmpty(currentUser))) {
    return await Axios.get(`${apiUrl}/remit/auth/vendor/${currentUser.vendor_key}`, {
      headers: {
        "Access-Control-Allow-Origin": "true",
        "Content-Type": "application/json",
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const forgotPassword = async (body: IAuth.IForgotPassword) => {
  return await Axios.post(`${baseApi}/remit/auth/forgotPassword`, body, {
    headers: {
      "Access-Control-Allow-Origin": "true",
      "Content-Type": "application/json",
      "X-Route-To": "authservice",
    },
  });
};

export const refreshToken = async (currentUser: IAuth.IIsAuthorisedProps) => {
  return await Axios.get(`${baseApi}/remit/auth/user/${currentUser.vendor_key}/getToken`, {
    headers: {
      "partner-type": "moneyhop",
      "X-Route-To": "authservice",
    },
  });
};

export const signOut = async (currentUser: IAuth.IIsAuthorisedProps) => {
  return await Axios.get(`${baseApi}/remit/user/${currentUser.vendor_key}/signOut`, {
    headers: {
      "partner-type": "moneyhop",
      Authorization: `${currentUser.idToken}`,
      "X-Route-To": "authservice",
    },
  });
};

export const initialXSRFToken = async () => {
  return await Axios.post(
    `${baseApi}/remit/csrf`,
    {},
    { headers: { "X-Route-To": "authservice" } },
  );
};

export const getRequestTime = async () => {
  return await Axios.get(`${baseApi}/remit/currentTime`, {
    headers: { "X-Route-To": "authservice" },
  });
};

export const verifyReCaptcha = async (body: IAuth.IReCaptcha) => {
  return await Axios.post(`${baseApi}/remit/auth/recaptcha/verify`, body, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "X-Route-To": "authservice",
    },
  });
};

export const handleQueryLogin = async (body: any) => {
  const apiBody = {
   queryId:body?.queryid,
  };

  return await Axios.get(`${baseApi}/remit/auth/login/vendor/${apiBody?.queryId}`, {
    headers: {
      "Access-Control-Allow-Origin": "true",
      "Content-Type": "application/json",
      "partner-type": "moneyhop",
      "X-Route-To": "authservice",
      accept: "*/*",
    },
  });
};
